var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogiclinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "Logo with cutout L shapes",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cutout-mask",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 134.40Q122.67 128.00 129.07 128.00L190.93 128.00Q197.33 128.00 197.33 134.40L197.33 320.00C213.33 330.67 229.33 341.33 229.33 352.00C229.33 364.80 195.20 381.87 186.67 384.00C170.67 384.00 154.67 362.67 144.00 352.00C128.00 336.00 122.67 330.67 122.67 320.00L122.67 134.40Z                M272.00 134.40Q272.00 128.00 278.40 128.00L340.27 128.00Q346.67 128.00 346.67 134.40L346.67 320.00C362.67 330.67 378.67 341.33 378.67 352.00C378.67 364.80 344.53 381.87 336.00 384.00C320.00 384.00 304.00 362.67 293.33 352.00C277.33 336.00 272.00 330.67 272.00 320.00L272.00 134.40Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "var(--color, currentColor)",
    mask: "url(#cutout-mask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogiclinkIcon);
export default __webpack_public_path__ + "static/media/logiclink-icon.51d8934a0e70b10d1897ab9ec2eeb438.svg";
export { ForwardRef as ReactComponent };